import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { forEach } from 'lodash';

import { NotificationsListService } from '../../notifications-list.service';
import { NotificationType, Notification } from '../../../../../modals/notification';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-notifications-list-filter',
  templateUrl: './notifications-list-filter.component.html',
  styleUrls: ['./notifications-list-filter.component.scss'],
  standalone: false,
})
export class NotificationsListFilterComponent implements OnInit {
  public isAllNotificationsRead: boolean;

  @Input() filter;

  constructor(private notificationsListService: NotificationsListService) {}

  ngOnInit() {
    this.notificationsListService.notificationsState.subscribe((notifications: Notification[]) => {
      if (notifications) {
        this.checkStatuses(notifications);
      }
    });
  }

  public onChangeNotificationType(notificationType: NotificationType): void {
    this.filter.params.notification_type = notificationType.id;
  }

  public checkStatuses(notifications: Notification[]): void {
    let countRead = 0;

    forEach(notifications, (notification: Notification) => {
      if (notification.status === 0) {
        countRead++;
      }
    });

    this.isAllNotificationsRead = countRead === 0;
  }
}
